export class JSONIDService {
  public IIMProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "IIM Call Predictor",
    "image": [
      "https://www.iquanta.in/blog/wp-content/uploads/2024/09/whatsapp-image-2024-09-19-at-30834-pm-66ebf964056dd.webp"
    ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "41,809"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "00",
      "highPrice": "00",
      "priceCurrency": "USD"
    }
  }

  public UPSCBreadcrumbList ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "UPSC Online Coaching",
      "item": "https://www.iquanta.in/upsc-coaching"  
    }]
  }

  public IITJEEPercentile = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "JEE Main Percentile Calculator",
      "item": "https://www.iquanta.in/jee-main-percentile-calculator"  
    }]
  }

  public skillsOrganization ={
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "DSA with patterns & Competitive Programming",
    "url": "https://www.iquanta.in/iskills/dsa-competitive-programming",
    "logo": "https://media.iquanta.in/ui_images/iquanta-logo-white.png"
  }

  public Thane = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CAT Coaching in Thane",
      "item": "https://www.iquanta.in/offline-center/thane"  
    }]
  }

  public IITJEEStudyMaterial = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "JEE Study Material",
      "item": "https://www.iquanta.in/jee-study-material"  
    }]
  }

  public JEECrashCourse = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "JEE Crash Course",
      "item": "https://www.iquanta.in/jee-crash-course"  
    }]
  }

  public Noida ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CAT Coaching in Greater Noida",
      "item": "https://www.iquanta.in/offline-center/noida"  
    }]
  }
  
  
  
  public BITSATProduct ={
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "BITSAT Crash Course",
    "image": [
      "https://www.iquanta.in/blog/wp-content/uploads/2024/11/bitsatCrash-Course.webp"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "276"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "5790",
      "highPrice": "29990",
      "priceCurrency": "INR"
    }
  }
  
  
  public BITSATCrashCourse = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "BITSAT Crash Course",
      "item": "https://www.iquanta.in/bitsat-crash-course"  
    }]
  }

  public  IITJEEMock ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "JEE Main Mock Test",
      "item": "https://www.iquanta.in/jee-mock-test"  
    }]
  }

  public IITJEEMaterial = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "JEE Study Material",
      "item": "https://www.iquanta.in/jee-study-material"  
    }]
  }
  
  public SkillsDSAMAANG = {
    "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "iQuanta",
        "item": "https://www.iquanta.in/"  
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "DSA Course",
        "item": "https://www.iquanta.in/iskills/dsa-course"  
      }]
      }
      
      public SkillsDSAPatterns ={
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "iQuanta",
        "item": "https://www.iquanta.in/"   
        },{
          "@type": "ListItem",
          "position": 2,
          "name": "DSA Pattern",
          "item": "https://www.iquanta.in/iskills/dsa-pattern"  
        }]
      }
     
      public SkillsLanding ={
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "iQuanta",
        "item": "https://www.iquanta.in/"  
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "iskills",
        "item": "https://www.iquanta.in/iskills"  
      }]
      }
     
      public SkillsDataAnalytics = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "iQuanta",
          "item": "https://www.iquanta.in/"   
        },{
          "@type": "ListItem",
          "position": 2,
          "name": "Data Analytics Course",
          "item": "https://www.iquanta.in/iskills/data-analytics-course"  
        }]
      }

  public PrayagrajBreadcrumbList={
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem",
      "position": 2,
      "name": "CAT coaching in Prayagraj",
      "item": "https://www.iquanta.in/offline-center/prayagraj"  
    }]
  }

 public TestMockFaq={
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "Is the CAT exam previous year paper enough for CAT preparation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, the CAT exam previous year paper is enough for CAT preparation as it gives insight about the CAT exam pattern. The students will get an idea about the structure, marking scheme and types of questions in different sections QA, VARC and LRDI."
      }
    },{
      "@type": "Question",
      "name": "What is the difficulty level of the CAT exam paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The difficulty level of the CAT exam paper usually ranges from moderate to difficult. As per the CAT 2024 paper analysis, the overall difficulty level was moderate. It is expected that CAT exam paper 2025 will follow the same paper pattern and difficulty level as in 2024."
      }
    },{
      "@type": "Question",
      "name": "What is the medium of a CAT question paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The medium of the CAT question paper is in English. It is a computer based test for a duration of 120 minutes. The paper will consist of both MCQ and Non-MCQ questions with +3 marks for each correct answer and -3 marks for each incorrect answer."
      }
    },{
      "@type": "Question",
      "name": "What are the different sections in the CAT exam paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The different sections in the CAT exam paper are - VARC (Verbal Ability and Reading Comprehension), QA (Quantitative Ability), DILR (Data Interpretation and logical reasoning). There are a total of 68 questions with 40 minutes for each section."
      }
    },{
      "@type": "Question",
      "name": "What are the benefits of last year's CAT exam paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Solving last year’s CAT exam paper allows the students to practice a wide range of questions from all the sections. This in turn will increase the speed and accuracy of the candidates aspiring to appear for the CAT exam."
      }
    },{
      "@type": "Question",
      "name": "Why to solve the CAT old paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The CAT exam has undergone various changes in the previous years therefore, it is very important to solve the CAT old paper to get a sense of the actual examination. The students will get an idea about the different types of sets and questions."
      }
    },{
      "@type": "Question",
      "name": "What should be the approach to solve the CAT exam previous year paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "One of the crucial factors while solving the CAT exam previous year paper is to learn how to skip and move ahead. An aspirant should first start with the easy questions first and then slowly and steadily should move towards the tough questions."
      }
    },{
      "@type": "Question",
      "name": "Where to get the previous year CAT exam paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The candidates can find the previous year CAT exam paper on the website of iQuanta from the year 2000 to 2024. Students will get the answers as well as the solutions to these previous year CAT exam papers."
      }
    },{
      "@type": "Question",
      "name": "By whom the CAT exam paper is prepared?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The CAT exam paper is prepared by different IIMs on the basis of rotation. For example: the CAT 2024 paper was prepared by IIM Calcutta. Also, based on previous years’ trends it is expected that the CAT 2025 paper will be prepared by IIM Kozhikode (subject to change)."
      }
    },{
      "@type": "Question",
      "name": "How to prepare for the CAT exam with last year's CAT exam paper?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The aspirants must complete the syllabus and should have a clear understanding about the basic concepts before solving the last year’s CAT exam paper. While solving the previous year’s CAT exam papers they will get an idea about the paper pattern and difficulty level."
      }
    }]
  }
  public CLATPreviousPapers = {
   
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CLAT Previous Year Question Papers",
      "item": "https://www.iquanta.in/test/clat-previous-papers"  
    }]
    }

  public CLATScholarBreadCrumb = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "clat scholarship test",
      "item": "https://www.iquanta.in/clat-scholarship-test"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "",
      "item": ""  
    }]
  }

  public CLATProduct = {
    "@context": "https://schema.org/", 
    "@type": "Product", 
    "name": "clat scholarship test",
    "image": "https://media.iquanta.in/ui_images/Analysis-Across.png",
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "offers": {
      "@type": "AggregateOffer",
      "url": "",
      "priceCurrency": "INR",
      "lowPrice": "4999",
      "highPrice": "74000"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "470"
    }
  }

  public IIMProductBreadCrumb = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "IIM Call Predictor",
      "item": "https://www.iquanta.in/iim-call-predictor"
    }]
  }

  public XATMockBreadcrumb = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "XAT Mock Test",
      "item": "https://www.iquanta.in/xat-mock-test"  
    }]
  }

  public TestMockBreadCrumbList = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "CAT Previous Year Papers",
      "item": "https://www.iquanta.in/test/cat-previous-papers"
    }]
  }

  public TestMockProduct =  {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "CAT Previous Year Papers",
    "image": [
      "https://www.iquanta.in/test/cat-previous-papers"
    ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "17683"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "0.00",
      "highPrice": "0.00",
      "priceCurrency": "INR"
    }
  }

  public LocalBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Iquanta",
    "image": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
    "@id": "",
    "url": "https://www.iquanta.in/",
    "telephone": "+91 8130900243",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "470, Lower Ground, Udyog Vihar Phase V, Sector 19",
      "addressLocality": "Gurugram",
      "postalCode": "122016",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 28.5005308,
      "longitude": 77.0856662
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      "https://facebook.com/iquanta.in",
      "https://www.instagram.com/iquanta.in/",
      "https://www.youtube.com/channel/UCJcXnTkWeIrXavsa_DUzq5w",
      "https://in.linkedin.com/company/iquanta-edu-services"
    ]
  }

  public hamirpurreadcrumb ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "JEE Coaching in Hamirpur",
      "item": "https://www.iquanta.in/jee-coaching-hamirpur"  
    }]
  }

  public iDesignBreadcrumb ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "Design Online Course",
      "item": "https://www.iquanta.in/idesign"  
    }]
  }

  // 9345089345

  public Organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Iquanta",
    "url": "https://www.iquanta.in/",
    "logo": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "8130900243",
      "contactType": "sales",
      "contactOption": "TollFree",
      "areaServed": "IN",
      "availableLanguage": ["en", "Hindi"]
    },
    "sameAs": [
      "https://facebook.com/iquanta.in",
      "https://www.instagram.com/iquanta.in/",
      "https://www.youtube.com/channel/UCJcXnTkWeIrXavsa_DUzq5w",
      "https://in.linkedin.com/company/iquanta-edu-services"
    ]
  }

  public WebSite = {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    "name": "Iquanta",
    "url": "https://www.iquanta.in/",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.iquanta.in/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }

  public Person = {
    "@context": "https://schema.org/",
    "@type": "Person",
    "name": "Indrajeet Singh",
    "url": "https://www.iquanta.in/",
    "image": "https://media.iquanta.in/ui_images/public_portal_img/ava.jpg",
    "sameAs": [
      "https://www.facebook.com/IndrajeetiQuanta",
      "https://www.linkedin.com/in/indralion/"
    ],
    "jobTitle": "CEO",
    "worksFor": {
      "@type": "Organization",
      "name": "iQuanta"
    }
  }

  public CAT2024Brand = {
    "@context": "https://schema.org/", 
    "@type": "Course", 
    "name": "CAT 2024 Full Course",
    "image": "https://media.iquanta.in/ui_images/CAT-2024.jpeg",
    "description": "Embark on your MBA journey with iQuanta's CAT 2024 course. Our meticulously designed course offers personalized learning paths, comprehensive study material, and extensive mock tests to help you ace the CAT 2024 exam",
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "offers": {
      "@type": "Offer",
      "url": "https://www.iquanta.in/cat-2024",
      "priceCurrency": "INR",
      "price": "32499",
      "priceValidUntil": "2024-03-31",
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "54233"
    }
  }

  public CAT2024Person = {
    "@context": "https://schema.org/",
    "@type": "Person",
    "name": "Indrajeet Singh",
    "url": "https://www.iquanta.in/",
    "image": "https://media.iquanta.in/ui_images/public_portal_img/ava.jpg",
    "sameAs": [
      "https://www.facebook.com/IndrajeetiQuanta",
      "https://www.linkedin.com/in/indralion/"
    ],
    "jobTitle": "CEO",
    "worksFor": {
      "@type": "Organization",
      "name": "iQuanta"
    }  
  }

  public CAT2024BreadCrumb = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CAT 2024 Course",
      "item": "https://www.iquanta.in/cat-2024"  
    }]
  }

  public CATScoreProduct =     {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "CAT Score Calculator",
    "image": [
      "https://www.iquanta.in/cat-score-calculator"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "83669"
    }
  }
 
 
  public CATScoreBreadcrumbList = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CAT Score Calculator",
      "item": "https://www.iquanta.in/cat-score-calculator"  
    }]
  }

  public GdpiBreadcrumbList= {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Best GDPI Course",
    "item": "https://www.iquanta.in/gdpi-course"  
  }]
}

  public XATScoreProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "XAT Score Calculator",
    "image": [
      "https://www.iquanta.in/xat-score-calculator"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "18076"
    }
  }

  public XATScoreBreadcrumbList = {
    "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "XAT Score Calculator",
    "item": "https://www.iquanta.in/xat-score-calculator"  
  }]
  } 

 

  public PatnaBreadcrumbList = {
    "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "iQuanta",
        "item": "https://www.iquanta.in/"  
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Best CAT Coaching in Patna",
        "item": "https://www.iquanta.in/offline-center/patna"  
      }]
      }
     
     
     
      public JaipurBreadcrumbList = {
    "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "iQuanta",
        "item": "https://www.iquanta.in/"  
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Best CAT Coaching in Jaipur",
        "item": "https://www.iquanta.in/offline-center/jaipur"  
      }]
      }

      public CATResultPage = {
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "iQuanta",
          "item": "https://www.iquanta.in/"  
        },{
          "@type": "ListItem", 
          "position": 2, 
          "name": "CAT Results 2024",
          "item": "https://www.iquanta.in/cat-results"  
        }]
      }

  // CLAT Schema


  public clatStudy ={
    "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CLAT Study Material",
    "item": "https://www.iquanta.in/free-clat-study-material"  
  }]
  }
  public ClatProduct2 = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "CLAT Online Coaching",
    "image": [
      "https://www.iquanta.in/clat-coaching"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "1832"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "49999",
      "highPrice": "99999",
      "priceCurrency": "INR"
    }
  }

  public CLATFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "What is the best CLAT coaching available for 2025?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "One of the best CLAT coaching available online is CLAT UG 2025 full course by iQuanta which provides all necessary content like mocks, practice material, revision and live sessions."
      }
    },{
      "@type": "Question",
      "name": "Are CLAT online courses a wise choice?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Online courses are simple to access and inexpensive for students based on their schedules. Students time and energy are saved. Learning is made simple by the wide range of online courses offered by iQuanta. You can enrol in the CLAT UG 2025 full course, which offers live sessions by top mentors, numerous practice exams and sessions for clearing up any questions. The course follows latest pattern, the sections covered are English Language, Legal Reasoning, Logical Reasoning, GK Current Affairs & Quantitative Techniques."
      }
    },{
      "@type": "Question",
      "name": "What is the difference between online and offline CLAT coaching?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Teachers can use a variety of online learning resources from CLAT online coaching programmes, such as live chats with students, virtual conference rooms, virtual whiteboards, audio, animations, and videos. While offline coaching requires regular time, energy, and your presence in the classroom, the benefit of offline classes is that you can ask questions immediately. Online coaching is more cost-effective and allows you to attend classes while studying wherever you choose. You can go for iQuanta CLAT UG full course for 2025 in which we provide mocks, live sessions, revision and 24x7 solving assistance."
      }
    },{
      "@type": "Question",
      "name": "Which online CLAT courses do iQuanta provide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "iQuanta provides CLAT UG 2025 full course, CLAT UG 2025 CRASH course and CLAT UG 2025 mock test series, you can check the details on the website."
      }
    },{
      "@type": "Question",
      "name": "Why is the iQuanta CLAT UG online course the best?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "iQuanta provides quality content with concept-based videos that are basically on the latest pattern and curated by CLAT toppers themselves, also there are recorded classes available for students who missed the live session with unlimited watch time."
      }
    }]
  }



  //CAT 2024

  public Cat2024BreadcrumbList = {
    "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT 2024",
    "item": "https://www.iquanta.in/cat-2024" 
    }]
  }

  public Cat2024organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "iQuanta",
    "url": "https://www.iquanta.in/cat-2024",
    "logo": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "8130900243",
      "contactType": "sales",
      "contactOption": "TollFree",
      "areaServed": "IN",
      "availableLanguage": ["en"]
    },
    "sameAs": [
    "https://facebook.com/iquanta.in",
    "https://www.instagram.com/iquanta.in/",
    "https://www.youtube.com/channel/UCJcXnTkWeIrXavsa_DUzq5w",
    "https://in.linkedin.com/company/iquanta-edu-services" 
    ]
  }

  public Cat2024person = {
    "@context": "https://schema.org/",
    "@type": "Person",
    "name": "Indrajeet Singh",
    "url": "https://www.iquanta.in/",
    "image": "https://media.iquanta.in/ui_images/public_portal_img/ava.jpg",
    "sameAs": [
      "https://www.facebook.com/IndrajeetiQuanta",
      "https://www.linkedin.com/in/indralion/"
    ],
    "jobTitle": "CEO",
    "worksFor": {
      "@type": "Organization",
      "name": "iQuanta" 
    }
  }

  public CAT2024FAQS = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "WHEN IS CAT 2024 EXAM?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The CAT Exam is conducted every year in November. Generally, its noticed that CAT is conducted on the last Sunday of November. According to the previous trend, we can assume that the CAT 2024 exam will be conducted on the 25th of November."
      }
    },{
      "@type": "Question",
      "name": "CAT 2024 preparation ONLINE VS OFFLINE?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Mode of preparation can have a huge impact on ones preparation. Generally, Online mode of preparation is considered to be more suitable than offline coaching, considering it provides updated and easily accessible content. When talking of factors like affordability and time efficiency online mode again has an edge over traditional offline coaching."
      }
    },{
      "@type": "Question",
      "name": "CAT 2024 Registrations will be opened on?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CAT 2024 Aspirants can expect CAT 2024 registrations to be opened by 1st week of August."
      }
    },{
      "@type": "Question",
      "name": "Which is the best CAT 2024 COURSE?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "There are various CAT courses available in the market, yet iQuanta’s CAT 2024 Course is considered to be the most liked course by aspirants. Offerings like Non-engineers conceptual videos, Dual mode of learning, and 24/7 doubt-solving facility make the Course interesting for the aspirants. With iQuanta one can have an unusual edge in the competition, as the content is highly relevant. Every year, several questions in the CAT exam are similar to what was taught in the iQuanta CAT classes."
      }
    },{
      "@type": "Question",
      "name": "When should one enrol for CAT 2024 COURSE?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "6 to 9 months of preparation is considered enough for the CAT Exam. The majority of the aspirants enrol for courses in Jan, March and May."
      }
    }]
  }

  //CAT Books


  //CSAT 

  public CSATBreadcrumb = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CSAT Course",
      "item": "https://www.iquanta.in/csat"  
    }]
  }

  public CSATCourse =  {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "CSAT Course",
    "image": [
      "https://www.iquanta.in/csat"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "643"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "5499",
      "highPrice": "7999",
      "priceCurrency": "INR"
    }
  }

  public CSATFAQS = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "What is CSAT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CSAT is a multiple choice question-based examination that is required at the preliminary level for civil service examination. It is based on CSE patterns and was introduced in 2011."
      }
    },{
      "@type": "Question",
      "name": "How to prepare for CSAT Course 2024?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To prepare for the CSAT exam in 2024, its essential to understand the detailed eligibility criteria beforehand. Once you meet the requirements, you can begin your preparation. Enrolling in a CSAT coaching program can provide structured guidance and help you understand the exam pattern and syllabus. One has to know the detailed eligibility criteria, before beginning CSAT preparation. With proper CSAT coaching and practical knowledge, a candidate can start their preparation."
      }
    },{
      "@type": "Question",
      "name": "Is the examination subjective or objective?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The CSAT exam is objective in nature, meaning it consists of multiple-choice questions where candidates select the correct answer from a set of options. However, its important to note that while the exam format is objective, it still requires candidates to have a strong understanding of the subjects and concepts being tested."
      }
    },{
      "@type": "Question",
      "name": "Is there a negative marking on the exam?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, there is indeed negative marking in the CSAT exam. For every incorrect answer, a fraction of the marks allocated to that question is deducted. Typically, its around one-third of the marks assigned to the question."
      }
    },{
      "@type": "Question",
      "name": "What are the subject options for mains?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Regarding the subject options for the mains examination, candidates have a diverse range of choices available. There are a total of 25 subjects offered for the CSAT course, allowing candidates to select the one that aligns with their academic background, interests, or expertise."
      }
    }]
  }



  public IPMAT = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "IPMAT Online Coaching",
      "item": "https://www.iquanta.in/ipmat"  
    }]
  }

  public IPMATProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "IPMAT Online Coaching",
    "image": [  
      "https://www.iquanta.in/ipmat"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "3201"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "2999",
      "highPrice": "60000",
      "priceCurrency": "INR"
    }
  }
  // Cat2025BreadcrumbList: any
   

  public IITProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "JEE Online Coaching",
    "image": [
      "https://www.iquanta.in/blog/wp-content/uploads/2024/09/jee-online-coaching.webp"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "ratingCount": "921"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "47899",
      "highPrice": "69999",
      "priceCurrency": "INR"
    }
  }




  //CAT 2025

 


public GMATNEWBreadCrumb = {
 "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "GMAT Online Coaching",
    "item": "https://www.iquanta.in/gmat"  
  }]
}

public GMATContact = {
 "@context": "https://schema.org",
  "@type": "Organization",
  "name": "iQuanta",
  "url": "https://www.iquanta.in/gmat",
  "logo": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "8130900243",
    "contactType": "sales",
    "contactOption": "TollFree",
    "areaServed": "IN",
    "availableLanguage": ["en"]
  },
  "sameAs": [
    "https://facebook.com/iquanta.in",
    "https://www.instagram.com/iquanta.in/",
    "https://www.youtube.com/channel/UCJcXnTkWeIrXavsa_DUzq5w",
    "https://in.linkedin.com/company/iquanta-edu-services"
  ]
}


public GMATProduct = {
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "GMAT Online Coaching",
  "image": [
    "https://www.iquanta.in/gmat"
   ],
  "brand": {
    "@type": "Brand",
    "name": "iQuanta"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "988"
  },
  "offers": {
    "@type": "AggregateOffer",
    "lowPrice": "34999",
    "highPrice": "69999",
    "priceCurrency": "INR"
  }
}

public IPMATHardCopy = {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Best IPMAT Books",
    "item": "https://www.iquanta.in/best-ipmat-books"  
  }]
}

public IPMATHardCopyBooks = {
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "Best IPMAT Books",
  "image": [
    "https://www.iquanta.in/best-ipmat-books"
   ],
  "brand": {
    "@type": "Brand",
    "name": "iQuanta"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.0",
    "ratingCount": "43"
  },
  "offers": {
    "@type": "AggregateOffer",
    "lowPrice": "9999",
    "highPrice": "2999",
    "priceCurrency": "INR"
  }
}

// CLAT Mock Test

public CLATMock = {
  "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CLAT Mock Test",
      "item": "https://www.iquanta.in/clat-mock-test"  
    }]
  }
  
  public CLATMockProduct = {
  "@context": "https://schema.org/",
      "@type": "Product",
      "name": "CLAT Mock Test",
      "image": [
        "https://www.iquanta.in/clat-mock-test"
       ],
      "brand": {
        "@type": "Brand",
        "name": "iQuanta"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "769"
      },
      "offers": {
        "@type": "AggregateOffer",
        "lowPrice": "4999",
        "highPrice": "9999",
        "priceCurrency": "INR"
      }
  }
  
  
  
  public ISBBreadcrumbList ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "ISB Application",
      "item": "https://www.iquanta.in/isb-application"  
    }]
  }

public CuetpgBreadcrumb ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CUET PG Mock Test",
    "item": "https://www.iquanta.in/cuet-pg-mock-test"  
  }]
}


public CmatMockBreadcrumb ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CMAT Mock Test Series 2024",
    "item": "https://www.iquanta.in/cmat-mock-test"  
  }]
}

public CatcrashBreadcrumb ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT Crash Course",
    "item": "https://www.iquanta.in/cat-crash-course"  
  }]
}



public StudyAbroadBreadcrumbList ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Study Abroad Courses in India",
    "item": "https://www.iquanta.in/study-abroad"  
  }]
}

public CUETUG ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CUET Online Coaching",
    "item": "https://www.iquanta.in/cuet"  
  }]
}

public CuetProduct={
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "CUET Online Coaching",
  "image": [  
    "https://www.iquanta.in/cuet"
   ],
  "brand": {
    "@type": "Brand",
    "name": "iQuanta"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "ratingCount": "721"
  },
  "offers": {
    "@type": "AggregateOffer",
    "lowPrice": "5499",
    "highPrice": "14999",
    "priceCurrency": "INR"
  }
}

public Varanasi ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT coaching in Varanasi",
    "item": "https://www.iquanta.in/offline-center/varanasi"  
  }]
}


public surat={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT coaching in Surat",
    "item": "https://www.iquanta.in/offline-center/surat"  
  }]
}

public srinagar ={
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "CAT coaching in Srinagar",
    "item": "https://www.iquanta.in/offline-center/srinagar"  
  }]
}

public jamshedpur ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT coaching in Jamshedpur",
    "item": "https://www.iquanta.in/offline-center/jamshedpur"  
  }]
}

public jammu = {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT Coaching in Jammu",
    "item": "https://www.iquanta.in/offline-center/jammu"  
  }]
}

public  IITJEEBreadcrumb = {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "JEE Online Coaching",
    "item": "https://www.iquanta.in/iit-jee-coaching"  
  }]
}

public Gurgaon ={
    
  "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "Best CAT Coaching in Gurgaon",
      "item": "https://www.iquanta.in/offline-center/gurgaon"  
    }]
 }

public Kolkata ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT Coaching in Kolkata",
    "item": "https://www.iquanta.in/offline-center/kolkata"  
  }]
 }


public Ranchi ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT coaching in Ranchi",
    "item": "https://www.iquanta.in/offline-center/ranchi"  
  }]
}


public Chandigarh ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT Coaching in Chandigarh",
    "item": "https://www.iquanta.in/offline-center/chandigarh"  
  }]
}
  

public Goa={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT coaching in Goa",
    "item": "https://www.iquanta.in/offline-center/goa"  
  }]
}

public banking ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Banking Online Course",
    "item": "https://www.iquanta.in/banking-online-course"  
  }]
}

public Bhubaneswar = {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
  "@type": "ListItem", 
  "position": 1, 
  "name": "iQuanta",
  "item": "https://www.iquanta.in/"  
  },{
  "@type": "ListItem", 
  "position": 2, 
  "name": "CAT Coaching in Bhubaneswar",
  "item": "https://www.iquanta.in/offline-center/bhubaneswar"  
  }]
  }

public Agra ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT coaching in Agra",
    "item": "https://www.iquanta.in/offline-center/agra"  
  }]
}

public Kochi = {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT Coaching in Kochi",
    "item": "https://www.iquanta.in/offline-center/kochi"  
  }]
}


public Raipur ={
  "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem",
      "position": 2,
      "name": "CAT coaching in Raipur",
      "item": "https://www.iquanta.in/offline-center/raipur"  
    }]
  }
   
   
   
   
   
  public Nagpur={
  "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem",
      "position": 2,
      "name": "CAT coaching in Nagpur",
      "item": "https://www.iquanta.in/offline-center/nagpur"  
    }]
  }


public Vadodara={
  "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "Best CAT Coaching in Vadodara",
      "item": "https://www.iquanta.in/offline-center/vadodara"  
    }]
  }

  public CatStudy ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CAT Study Material",
      "item": "https://www.iquanta.in/free-cat-study-material"  
    }]
  }

  public MBAInterviewCall = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "MBA Interview Preparation",
      "item": "https://www.iquanta.in/mba-interview-call"  
    }]
  }


  public NeetMock = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "NEET Mock Test",
      "item": "https://www.iquanta.in/neet-mock-test"  
    }]
  }


public Indore={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Best CAT Coaching in Indore",
    "item": "https://www.iquanta.in/offline-center/indore"  
  }]
}

public CUETMock = {
  "@context": "https://schema.org/", 
"@type": "BreadcrumbList", 
"itemListElement": [{
  "@type": "ListItem", 
  "position": 1, 
  "name": "iQuanta",
  "item": "https://www.iquanta.in/"  
},{
  "@type": "ListItem", 
  "position": 2, 
  "name": "CUET Mock Test",
  "item": "https://www.iquanta.in/cuet-mock-test"  
}]
}

public CUETBrand = {
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "CUET Mock Test",
  "image": [
    "https://www.iquanta.in/cuet-mock-test"
   ],
  "brand": {
    "@type": "Brand",
    "name": "iQuanta"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "ratingCount": "3567"
  },
  "offers": {
    "@type": "AggregateOffer",
    "lowPrice": "1999",
    "highPrice": "6999",
    "priceCurrency": "INR"
  }
}

public Bhopal ={
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "CAT Coaching in Bhopal",
    "item": "https://www.iquanta.in/offline-center/bhopal"  
  }]
}
public Lucknow ={
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "CAT Coaching in Lucknow",
    "item": "https://www.iquanta.in/offline-center/lucknow"  
  }]
}
 
public Jhansi ={
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "CAT Coaching in Jhansi",
    "item": "https://www.iquanta.in/offline-center/jhansi"  
  }]
}
 
 
public Ludhiana={
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "CAT Coaching in Ludhiana",
    "item": "https://www.iquanta.in/offline-center/ludhiana"  
  }]
}
 
public Rajkot={
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "CAT Coaching in Rajkot",
    "item": "https://www.iquanta.in/offline-center/rajkot"  
  }]
}





public IPMATStudyMaterial ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "IPMAT Study Material",
    "item": "https://www.iquanta.in/free-ipmat-study-material"  
  }]
}



public CuetPastPapers ={
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CUET Previous Year Paper",
    "item": "https://www.iquanta.in/test/cuet-previous-papers"  
  }]
}

public ClatBreadcrumbList = {
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CLAT Online Coaching",
    "item": "https://www.iquanta.in/clat-coaching"  
  }]
  }

  public ClatProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "CLAT Online Coaching",
    "image": [
      "https://www.iquanta.in/clat-coaching"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "3846"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "74999",
      "highPrice": "149999",
      "priceCurrency": "INR"
    }
  }

  public ClatProduct1 = {
   "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What is the best CLAT coaching available for 2026?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "One of the best CLAT coaching available online is CLAT UG 2026 full course by iQuanta which provides all necessary content like mocks, practice material, revision and live sessions."
    }
  },{
    "@type": "Question",
    "name": "Are CLAT online courses a wise choice?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely. Online courses are simple to access and inexpensive for students based on their schedules. Students time and energy are saved. Learning is made simple by the wide range of online courses offered by iQuanta. You can enrol in the CLAT UG 2026 full course, which offers live sessions by top mentors, numerous practice exams and sessions for clearing up any questions. The course follows latest pattern, the sections covered are English Language, Legal Reasoning, Logical Reasoning, GK Current Affairs & Quantitative Techniques."
    }
  },{
    "@type": "Question",
    "name": "What is the difference between online and offline CLAT coaching?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Teachers can use a variety of online learning resources from CLAT online coaching programmes, such as live chats with students, virtual conference rooms, virtual whiteboards, audio, animations, and videos. While offline coaching requires regular time, energy, and your presence in the classroom, the benefit of offline classes is that you can ask questions immediately. Online coaching is more cost-effective and allows you to attend classes while studying wherever you choose. You can go for iQuanta CLAT UG full course for 2026 in which we provide mocks, live sessions, revision and 24x7 solving assistance."
    }
  },{
    "@type": "Question",
    "name": "Which online CLAT courses do iQuanta provide?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "iQuanta provides CLAT UG 2026 full course, CLAT UG 2026 CRASH course and CLAT UG 2026 mock test series, you can check the details on the website."
    }
  },{
    "@type": "Question",
    "name": "Why is the iQuanta CLAT UG online course the best?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "iQuanta provides quality content with concept-based videos that are basically on the latest pattern and curated by CLAT toppers themselves, also there are recorded classes available for students who missed the live session with unlimited watch time."
    }
  }]
   }


   public SiliguriBreadcrumbList ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "iQuanta",
    "item": "https://www.iquanta.in/"  
    },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "CAT Coaching in Siliguri",
    "item": "https://www.iquanta.in/offline-center/siliguri"  
    }]
  }
  
  
  public ClatBooksBreadcrumbList={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "Best CLAT Books",
      "item": "https://www.iquanta.in/best-clat-books"  
    }]
  }
  
  
  public ClatBooksProduct={
    "@context": "https://schema.org/",
      "@type": "Product",
      "name": "Best CLAT Books",
      "image": [
        "https://www.iquanta.in/blog/wp-content/uploads/2024/12/best-cLat-books.webp"
       ],
      "brand": {
        "@type": "Brand",
        "name": "iQuanta"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "234"
      },
      "offers": {
        "@type": "AggregateOffer",
        "lowPrice": "8999",
        "highPrice": "14999",
        "priceCurrency": "INR"
      }
  }



  public NIDBreadcrumbList ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "NID Online Coaching",
      "item": "https://www.iquanta.in/idesign/nid"  
    }]
  }



  public UCEEDBreadcrumbList ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "UCEED Online Coaching",
      "item": "https://www.iquanta.in/idesign/uceed"  
    }]
  }



  public CEEDBreadcrumbList = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "CEED Online Coaching",
      "item": "https://www.iquanta.in/idesign/ceed"  
    }]
  }


  public NIFTBreadcrumbList ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "NIFT Online Course",
      "item": "https://www.iquanta.in/idesign/nift"  
    }]
  }


  public BArchBreadcrumbList = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "BArch Online Coaching",
      "item": "https://www.iquanta.in/idesign/barch"  
    }]
  }
   

  public NeetBreadcrumbList={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "NEET Online Coaching",
      "item": "https://www.iquanta.in/neet-coaching"  
    }]
  }

  public NeetProduct ={
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "NEET Online Coaching",
    "image": [
      "https://www.iquanta.in/blog/wp-content/uploads/2024/12/neet-coaching.webp"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "2256"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "24999",
      "highPrice": "90999",
      "priceCurrency": "INR"
    }
  }

  public NeetStudyMaterial ={
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
      },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "NEET Study Material",
      "item": "https://www.iquanta.in/neet-study-material"  
    }]
  }
   
  public Cat2025organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "iQuanta",
    "url": "https://www.iquanta.in/cat-2025",
    "logo": "https://www.iquanta.in/assets/img/favicon-32x32.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "8130900243",
      "contactType": "sales",
      "contactOption": "TollFree",
      "areaServed": "IN",
      "availableLanguage": ["en"]
    },
    "sameAs": [
      "https://facebook.com/iquanta.in",
      "https://www.instagram.com/iquanta.in/",
      "https://www.youtube.com/channel/UCJcXnTkWeIrXavsa_DUzq5w",
      "https://in.linkedin.com/company/iquanta-edu-services"
    ]
  }
   


} 


